export const adminRoles = ['Administrator', 'Support']

export const agencyAdminRoles = ['OfficeAdministrator']

export const agentRoles = ['Agent']

export const agencyRoles = [...agencyAdminRoles, ...agentRoles]

export const brandRoles = ['BrandAdministrator']
